module.exports = __webpack_public_path__ + "static/media/book-open-svgrepo-com (3).11a8fef1.svg";